<template>
  <div class="qr_code">
    <van-nav-bar
      title="销巴达人"
      right-text="保存图片"
      left-arrow
      @click-left="goBack"
      @click-right="preservation"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <!-- <img :src="newSrc" /> -->
      <div class="content">
        <p class="header_img" v-if="memberInfo.infos">
          <img :src="memberInfo.infos.head_pic" @error="defaultAvatar()" />
        </p>
        <p class="name">{{memberInfo.nickname}}</p>
        <p class="label">
          <img src="../../assets/member/talent.png" />
        </p>
        <img class="qrcode" :style="codestyle" :src="code" @error="defaultPro()" />
        <p class="tip">
          <img src="../../assets/member/scan.png" />扫一扫换购积分商品
        </p>
      </div>
    </div>
    <van-popup class="tipMSG" v-model="showTip">
      <div class="box1">
        <img src="../../assets/common/BG@2x.png" alt />
        <p class="title">温馨提示</p>
        <p class="tips">{{TipMsg}}</p>
        <span class="right right_big" @click="confirm()">确定</span>
      </div>
    </van-popup>
  </div>
</template>
<script>
import avatarDefault from "@/assets/common/avatar.png";
import productDefault from "@/assets/common/preload.png";
import talentBg from "@/assets/member/talentBg.png";
export default {
  data() {
    return {
      memberInfo: {},
      share_Url: "",
      code: "",
      TipMsg: "",
      showTip: false,
      codestyle: {
        height: (document.body.clientWidth - 50) * 0.6 + "px"
      },
      isiOSX: false,
      newSrc: ""
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    var baseUrl = window.location.href.split(this.$route.path);
    this.$api.setToken(this.$route.query.token);
    this.share_Url = baseUrl[0] + "/talentGoods";
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$api
        .get("/member/member/user/detail")
        .then(res => {
          if (res.infos) {
            res.infos.head_pic = res.infos.head_pic || avatarDefault;
          }
          this.memberInfo = res;

          this.getCode();
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    getCode() {
      // this.share_Url = this.share_Url+'?name='+encodeURI(this.memberInfo.nickname)+'&avatar='+this.memberInfo.infos.head_pic+'&talent_id='+this.memberInfo.id;
      this.$api
        .get("/member/member/talent/get/trade/qrcode", { url: this.share_Url })
        .then(res => {
          this.code = res.img;
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else if (err.code == 200401 || err.code == 200410) {
            this.showPopup(message);
          } else {
            this.$toast(message);
          }
        });
    },
    showPopup(msg) {
      this.showTip = true;
      this.TipMsg = msg;
    },
    confirm() {
      this.goBack();
    },
    defaultAvatar() {
      var img = event.srcElement;
      img.src = avatarDefault;
      img.onerror = null; //防止闪图
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = productDefault;
      img.onerror = null; //防止闪图
    },
    goBack() {
      this.params("", "", "goBack");
    },
    preservation() {
      let canvas = document.createElement("canvas");
      canvas.width = 690;
      canvas.height = 928;
      let ctx = canvas.getContext("2d");

      let bg = new Image();
      bg.setAttribute("crossorigin", "anonymous");
      bg.src = talentBg;
      bg.onload = () => {
        ctx.drawImage(bg, 0, 0, 690, 928);
        let hd = new Image();
        hd.setAttribute("crossorigin", "anonymous");
        hd.src = this.memberInfo.infos.head_pic;
        hd.onload = () => {
          ctx.save();
          ctx.arc(346, 136, 64, 0, 2 * Math.PI);
          ctx.clip();
          ctx.drawImage(hd, 282, 72, 128, 128);
          ctx.restore();
          ctx.font = "bold 36px arial, '黑体'";
          ctx.textBaseline = "middle";
          ctx.textAlign = "center";
          var left = canvas.width / 2;
          var top = canvas.height - 696;
          ctx.fillStyle = "#000";
          ctx.fillText(this.memberInfo.nickname, left, top);
          this.newSrc = canvas.toDataURL();
          let cd = new Image();
          cd.setAttribute("crossorigin", "anonymous");
          cd.src = this.code;
          cd.onload = () => {
            ctx.drawImage(cd, 146, 370, 396, 396);
            this.newSrc = canvas.toDataURL();
            this.params(this.newSrc, this.newSrc, "preservation");
          };
        };
      };
    }
  }
  //mounted() {
  //}
};
</script>
<style lang="less" scoped>
.qr_code {
  min-height: 100%;
  box-sizing: border-box;
  background: #f5ad1d;
  .van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 24px;
    border: none;
    box-shadow: none;
    background: #f5ad1d;
    .van-nav-bar__title {
      color: #ffffff;
      font-size: 18px;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #ffffff;
      font-size: 18px;
      font-weight: 400;
    }
    .van-icon {
      color: #ffffff;
    }
  }
  .van-hairline--bottom:after {
    border-bottom-width: 0px !important;
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    padding: 66px 15px 0;
    .content {
      height: auto;
      background: #ffffff;
      border-radius: 8px;
      padding: 0 10px 40px;
      .header_img {
        text-align: center;
        img {
          display: inline-block;
          width: 64px;
          height: 64px;
          border: solid 4px #ffffff;
          border-radius: 50%;
          margin-top: -34px;
        }
      }
      .name {
        color: #333;
        font-size: 18px;
        text-align: center;
        height: 34px;
        line-height: 34px;
        font-weight: bold;
      }
      .label {
        text-align: center;
        img {
          width: 70px;
          display: inline-block;
        }
      }
      .qrcode {
        width: 60%;
        margin-left: 20%;
      }
      .tip {
        color: #333;
        font-size: 15px;
        text-align: center;
        line-height: 24px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          vertical-align: middle;
        }
      }
    }
  }
  .tipMSG {
    width: 70%;
    border-radius: 10px;
    .box1 {
      img {
        display: block;
        width: 100%;
      }
      .title {
        color: #333;
        font-size: 15px;
        font-weight: 600;
        line-height: 47px;
        margin-top: 8px;
        text-align: center;
      }
      .tips {
        color: #333;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        margin-bottom: 30px;
        padding: 0 10px;
      }
      span {
        width: 50%;
        border-top: solid 1px #f2f2f2;
        line-height: 43px;
        color: #999;
        font-size: 14px;
        text-align: center;
        display: inline-block;
      }
      .right {
        color: #e6212f;
        width: calc(50% - 1px);
        border-left: solid 1px #f2f2f2;
      }
      .right_big {
        width: 100%;
        border-left: none;
      }
    }
  }
}
</style>


